<template>
    <div class="file-style-box">
        <div class='upload-file-item'>
            <img :src="imgsrc[getEnd(file.fileName)]" alt="">
            <div>
                <p class='file-name'>
                    <span class='name'>{{ file.fileName }}</span>
                </p>
                <div class='option'>
                    <!-- <span class='size'>{{file.size | toKB}}kb</span> -->
                    <div>
                        <span v-if='showDel' @click='previewHandler(file.fileUrl)' class='preview mr10'>预览</span>
                        <a v-if='!showDel' @click='downLoadHandler' class='preview' :href="file.fileUrl">下载</a>
                        <span v-if='showDel && type != 1' class='mr10 success'>上传完成</span>
                    </div>
                </div>
                <div class='delBtn' v-if='showDel && type != 1' @click='cancelHanlder(file)'>
                    <img src="@/assets/del.png" alt="">
                </div>
            </div>
        </div>
        <el-dialog title="图片预览" width="800px" class="imgDlgBox" :visible.sync="imgDlgVisible"
            :close-on-click-modal="true" :modal="false" append-to-body>
            <div style="width: 100%;overflow-y: auto;text-align: center;">
                <img :src="imgUrl" alt="">
            </div>
        </el-dialog>
    </div>

</template>
  
<script>

export default {
    name: "Uploadfileitem",
    props: {
        file: {
            type: Object,
            default: {}
        },
        showDel: {
            type: Boolean,
            default: false
        },
        type: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            imgDlgVisible: false,
            imgUrl: '',
            pdfUrl: '',
            imgsrc: {
                /*
                  *imgsrc 是关于内部静态图片的显示的路径，需要自己设置
                  *示例"xls": require('@/assets/image/xls.png'),
                  xis的文件所需要加载的路径是；assets文件下的image文件夹下的xls.png
              */
                //   "rar": require('@'),
                //   "zip": require('@'),
                "pdf": require('@/assets/Pdf.png'),
                "jpg": require('@/assets/Jpg.png'),
                "jpeg": require('@/assets/JPEG.png'),
                "png": require('@/assets/Png.png'),
                //   "doc": require('@'),
                //   "docx": require('@'),
                "txt": require('@/assets/txt.png'),
                //   "xls": require('@/assets/image/xls.png'),
            }
        }
    },
    filters: {
        toKB(val) {
            return (Number(val) / 1024).toFixed(0);
        }
    },
    methods: {
        getEnd(name) {
            let arr = name.split('.')
            return arr[arr.length - 1]
        },
        cancelHanlder(item) {
            this.$emit('cancel', item)
        },
        previewHandler(data) {
            if (data) {
                const addTypeArray = data.split(".");
                const addType = addTypeArray[addTypeArray.length - 1];
                if (addType === "pdf") {
                    // window.location.href = this.$store.getters.getConfig.imgUrl + '/' + data
                    // let routeData = this.$router.resolve({ path: "/insurancePdf", query: { url: this.$store.getters.getConfig.imgUrl + '/' + data, showBack: false } });
                    window.open(this.$store.getters.getConfig.imgUrl + '/' + data, '预览PDF', 'top=10,left=10,width=800,height=500');
                } else if (addType === "doc") {
                    window.open(
                        `https://view.officeapps.live.com/op/view.aspx?src=${data}`
                    );
                } else if (addType === "txt") {
                    window.open(this.$store.getters.getConfig.imgUrl + '/' + data, '预览TXT', 'top=10,left=10,width=800,height=500');
                } else if (['png', 'jpg', 'jpeg'].includes(addType)) { // 图片类型
                    this.imgDlgVisible = true
                    this.imgUrl = this.$store.getters.getConfig.imgUrl + '/' + data
                }
            }
        },
    }
}
</script>
<style scoped>
.file-style-box {
    padding: 10px 10px 0 0;
}

.imgDlgBox .el-dialog__body {
    text-align: center;
}

.imgDlgBox .el-dialog__body img {
    width: auto;
    height: auto;
}

.upload-file-item {
    background: #e5e2e2a3;
    border-radius: 4px;
    padding: 5px 10px;
    margin-bottom: 10px;
    display: flex;
    font-size: 14px;
    width: 236px;
    box-sizing: border-box;
    position: relative;
}

.upload-file-item img {
    width: 32px;
    height: 40px;
    margin-top: 5px;
    margin-right: 10px;
}

.upload-file-item .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.upload-file-item .file-name {
    width: 163px;
    display: flex;
    flex-wrap: nowrap;
    font-size: 14px;
    color: #333;
    font-weight: 400;
}

.upload-file-item .file-name .name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.upload-file-item .file-name .end {
    flex: 0 0 auto;
}

.upload-file-item .file-name .el-button {
    border: none;
    padding: 0px;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}


.upload-file-item .size {
    color: #969696;
}

.upload-file-item .success {
    color: #78C06E;
}

.upload-file-item .delBtn {
    position: absolute;
    top: -14px;
    right: -18px;
    cursor: pointer;
}

.upload-file-item .delBtn img {
    width: 30px;
    height: 30px
}


.upload-file-item .preview {
    color: #0286DF;
    cursor: pointer;
}

.upload-file-item .mr10 {
    margin-right: 10px;
}
</style>
  